module.exports = __webpack_public_path__ + "static/img/wxbj2.6c15d0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wxbj2.jpg
// module id = uHYl
// module chunks = 128